// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2ra2z","additionalInfo":"AgreementModal_additionalInfo__37LS6"};